import React, { useRef, useMemo } from 'react'
import Edit from './Edit'

export default ({ onSubmit, title, allowCollector }) => {
  const modalRef = useRef()

  // extProps 额外参数，用作判断一些定制需求
  const open = (data, extProps, isBatch, config) => {
    if (modalRef.current) {
      modalRef.current.open(data, extProps, isBatch, config)
    }
  }

  const close = () => {
    if (modalRef.current) {
      modalRef.current.close()
      // 打开详情吧
    }
  }

  const DittoFormModalRender = useMemo(() => {
    return (
      <Edit
        ref={modalRef}
        onSubmit={onSubmit}
        title={title}
        allowCollector={allowCollector}
      />
    )
  }, [onSubmit, modalRef])

  return {
    open,
    close,
    DittoFormModalRender,
  }
}
